<template>
    <!-- <div>
    <section>-->
    <!-- <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" height="1000"> -->
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="cerveceria">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold brown--text text--darken-4"
                                >Cervecería</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cerrar</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12 md4>
                                <v-radio-group row v-model="orden" :mandatory="true">
                                    <v-radio
                                        label="Por país"
                                        value="por_pais"
                                        color="red darken-4"
                                        @change="onPorPais"
                                    ></v-radio>
                                    <v-radio
                                        label="Por tipo de cerveza"
                                        value="por_tipo"
                                        color="red darken-4"
                                        @change="onPorTipo"
                                    ></v-radio>
                                </v-radio-group>
                            </v-flex>

                            <v-flex xs4 md4 v-if="orden === 'por_tipo'">
                                <v-select
                                    :items="tiposCervezas"
                                    item-text="tipo"
                                    item-value="tipoid"
                                    v-model="selectedBeerTypeID"
                                    label="Cerveza"
                                    color="red darken-4"
                                    item-color="red darken-4"
                                    no-data-text="No hay tipos de cerveza registrados"
                                    v-on:input="onSelectBeerType"
                                ></v-select>
                            </v-flex>
                            <v-flex xs4 md4 v-if="orden === 'por_tipo'">
                                <v-select
                                    :disabled="!bEnableCountrySelect"
                                    :items="paises"
                                    item-text="pais"
                                    item-value="paisid"
                                    v-model="selectedCountryID"
                                    label="País"
                                    color="red darken-4"
                                    item-color="red darken-4"
                                    no-data-text="No hay países registrados"
                                    v-on:input="onSelectCountry"
                                ></v-select>
                            </v-flex>

                            <v-flex xs6 md4 v-if="orden === 'por_pais'">
                                <v-select
                                    :items="paises"
                                    item-text="pais"
                                    item-value="paisid"
                                    v-model="selectedCountryID"
                                    label="País"
                                    color="red darken-4"
                                    item-color="red darken-4"
                                    no-data-text="No hay países registrados"
                                    v-on:input="onSelectCountry"
                                ></v-select>
                            </v-flex>
                            <v-flex xs6 md4 v-if="orden === 'por_pais'">
                                <v-select
                                    :disabled="!bEnableBeerSelect"
                                    :items="tiposCervezas"
                                    item-text="tipo"
                                    item-value="tipoid"
                                    v-model="selectedBeerTypeID"
                                    label="Cerveza"
                                    color="red darken-4"
                                    item-color="red darken-4"
                                    no-data-text="No hay tipos de cerveza registrados"
                                    v-on:input="onSelectBeerType"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <!-- Flex para la lista de cervezas resultado de la búsqueda: -->
                            <v-flex xs12 sm4>
                                <v-card>
                                    <v-toolbar dense color="red darken-4" dark flat>
                                        <v-toolbar-title>Cervezas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <!-- <v-icon color="white" large>mdi-bottle-soda</v-icon> -->
                                        <img
                                            position="left"
                                            width="23"
                                            src="@/assets/iconos/cerveceria_b.png"
                                        />
                                    </v-toolbar>

                                    <!-- style="height: 470px; max-height:100%" -->
                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-5"
                                    >
                                        <v-list-item-group
                                            v-model="selectedBeerIndex"
                                            color="red darken-4"
                                            :mandatory="true"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(item, i) in cervezas"
                                                :key="i"
                                                @click="selectBeer(item.cervezaid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{ item.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>
                            <!-- Termina flex para la lista de cervezas resultado de la búsqueda -->
                            <!-- Info de la cerveza seleccionada: *********************** -->
                            <v-flex xs12 sm8>
                                <v-card v-if="cervezas.length !== 0" color="grey lighten-5">
                                    <v-container>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-card-text
                                                    class="font-weight-medium red--text text--darken-4"
                                                    :class="beerNameClass"
                                                >{{ cerveza.nombre }}</v-card-text>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs7>
                                                <v-card-text>
                                                    <div
                                                        class="subtitle-1 font-weight-medium red--text text--darken-4"
                                                    >{{ cerveza.precio }}</div>
                                                    <div
                                                        class="subtitle-1 font-weight-medium red--text text--darken-4"
                                                    >{{ cerveza.tipo }}</div>
                                                    <div
                                                        class="subtitle-2 font-weight-medium red--text text--darken-4"
                                                    >{{ cerveza.pais }}</div>
                                                </v-card-text>
                                            </v-flex>
                                            <v-flex xs5>
                                                <v-img
                                                    class="red--text text--darken-4 align-end"
                                                    height="280px"
                                                    contain
                                                    :src="cerveza.imagen"
                                                    eager
                                                ></v-img>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-row
                                                    v-if="cerveza.nombre !==''"
                                                    align="center"
                                                    class="mx-3"
                                                >
                                                    <v-rating
                                                        :value="cerveza.rating"
                                                        color="amber"
                                                        dense
                                                        half-increments
                                                        readonly
                                                        size="14"
                                                    ></v-rating>
                                                </v-row>

                                                <v-card-text class="text--primary">
                                                    <div>{{ cerveza.descripcion }}</div>
                                                </v-card-text>
                                            </v-flex>
                                        </v-layout>

                                        <v-divider v-if="cerveza.nombre !==''" class="mx-4"></v-divider>

                                        <v-layout row v-if="cerveza.nombre !==''">
                                            <v-flex xs2 md1>
                                                <v-card-text>
                                                    <v-icon
                                                        color="red darken-4"
                                                        large
                                                    >mdi-tag-text-outline</v-icon>
                                                </v-card-text>
                                            </v-flex>
                                            <v-flex xs10 md11>
                                                <v-card-text class="text--primary">
                                                    <div>{{ cerveza.tag }}</div>
                                                </v-card-text>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para informar que no hubo resultados en una búsqueda de productos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="noResults" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">
                                            <v-icon>search</v-icon>&nbsp; Búsqueda de Cervezas
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>

                                        <v-icon>mdi-glass-mug</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <img height="55" :src="navMainLogo" />
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    :class="noResultsTextClass"
                                                >No se encontraron productos con estos parámetros.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="red darken-4"
                                            class="text-none"
                                            text
                                            @click="noResults = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *********************************** -->
                    </v-container>
                </div>
                <!-- </section> -->
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- </div> -->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'cerveceria',
    data() {
        return {
            orden: 'por_pais',
            bEnableCountrySelect: true,
            bEnableBeerSelect: false,
            selectedBeerTypeID: -1,
            selectedCountryID: -1
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('cleanBeerList');
        this.selectedBeerIndex = -1;
        next();
    },
    created() {
        if (this.paises.length === 0) {
            console.log('Haciendo request de países...');
            this.$store.dispatch('fetchPaises');
        }

        if (this.tiposCervezas.length === 0) {
            console.log('Haciendo request de tipos de cervezas...');
            this.$store.dispatch('fetchTiposCervezas');
        }

        //Se seleccionan todas las cervezas de todos los países:
        this.selectedCountryID = 0;
        this.onSelectCountry();
        this.selectedBeerTypeID = 0;
        this.onSelectBeerType();
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'navMainLogo',
            'paises',
            'tiposCervezas',
            'cervezas'
        ]),
        selectedBeerIndex: {
            get() {
                return this.$store.getters.selectedBeerIndex;
            },
            set(selectedBeerIndex) {
                this.$store.dispatch(
                    'updateSelectedBeerIndex',
                    selectedBeerIndex
                );
            }
        },
        cerveza: {
            get() {
                return this.$store.getters.cerveza;
            },
            set(cerveza) {
                this.$store.dispatch('updateCerveza', cerveza);
            }
        },
        noResults: {
            get() {
                return this.$store.getters.noResults;
            },
            set(noResults) {
                this.$store.dispatch('updateNoResults', noResults);
            }
        },

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '400px';
            } else {
                height = '500px';
            }
            return height;
        },

        breakPoint() {
            var bkPoint = 'xs';
            if (this.$vuetify.breakpoint.sm) {
                bkPoint = 'sm';
            } else if (this.$vuetify.breakpoint.md) {
                bkPoint = 'md';
            } else if (this.$vuetify.breakpoint.lg) {
                bkPoint = 'lg';
            } else if (this.$vuetify.breakpoint.xl) {
                bkPoint = 'xl';
            }
            return bkPoint;
        },
        beerNameClass() {
            var nameClass = '';
            if (this.$vuetify.breakpoint.xs) {
                nameClass = 'subtitle-1 font-weight-bold';
            } else if (this.$vuetify.breakpoint.sm) {
                nameClass = 'subtitle-1 font-weight-bold';
            } else if (this.$vuetify.breakpoint.md) {
                nameClass = 'title font-weight-bold';
            } else if (this.$vuetify.breakpoint.lg) {
                nameClass = 'headline font-weight-bold';
            } else {
                nameClass = 'headline font-weight-bold';
            }
            return nameClass;
        },
        noResultsTextClass() {
            var textClass = '';
            if (this.$vuetify.breakpoint.xs) {
                textClass = 'body-1';
            } else if (this.$vuetify.breakpoint.sm) {
                textClass = 'subtitle-2';
            }
            if (this.$vuetify.breakpoint.md) {
                textClass = 'subtitle-1';
            }
            return textClass;
        }
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onPorPais() {
            this.orden = 'por_pais';
            this.bEnableCountrySelect = true;
            this.bEnableBeerSelect = false;
            this.selectedBeerTypeID = -1;
            this.selectedCountryID = -1;
        },
        onPorTipo() {
            this.orden = 'por_tipo';
            this.bEnableCountrySelect = false;
            this.bEnableBeerSelect = true;
            this.selectedBeerTypeID = -1;
            this.selectedCountryID = -1;
        },
        selectBeer(cervezaid) {
            var i;
            for (i = 0; i < this.cervezas.length; i++) {
                if (this.cervezas[i].cervezaid === cervezaid) {
                    this.cerveza = this.cervezas[i];
                }
            }
        },
        onSelectBeerType() {
            if (this.selectedBeerTypeID !== -1) {
                this.bEnableCountrySelect = true;
                if (this.orden === 'por_pais') {
                    this.fetchBeers();
                } else {
                    this.selectedCountryID = -1;
                }
            } else {
                this.bEnableCountrySelect = false;
            }
            console.log('countryID = ', this.selectedCountryID);
        },
        onSelectCountry() {
            if (this.selectedCountryID !== -1) {
                this.bEnableBeerSelect = true;
                if (this.orden === 'por_tipo') {
                    this.fetchBeers();
                } else {
                    this.selectedBeerTypeID = -1;
                }
            } else {
                this.bEnableBeerSelect = false;
            }
            console.log('BeerTypeID = ', this.selectedBeerTypeID);
        },
        fetchBeers() {
            var queryData = {
                paisID: this.selectedCountryID,
                tipoCervezaID: this.selectedBeerTypeID
            };
            // this.$store.dispatch('fetchBeers', queryData).then(response => {
            //     console.log("Respuesta Recibida");
            //     if (this.cervezas.length > 0) {
            //         this.selectedBeerIndex = 0;
            //         this.selectBeer(this.cervezas[this.selectedBeerIndex].cervezaid);
            //     }
            // });
            this.$store.dispatch('fetchBeers', queryData);
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}
.cerveceria {
    /* background: url('../assets/maksym-kaharlytskyi-3uJt73tr4hI-unsplash1.png'); */
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}
.bourbon {
    font-family: 'bourbon';
    font-weight: bold;
}

.catabocata-red {
    color: #bc1212;
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    /* font-size: 2.8em; */
    /* font-size: 500px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>